export const SPANISH_NATIONALITY = "ESP";
